import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { InternalButtonLink } from "./InternalButtonLink";

export const ButtonLink = styled(InternalButtonLink)(({ theme }) => ({
    color: theme.palette.primary.main,
    float: 'right',
    textTransform: 'none'
}));

export const HeaderContainer = styled(Grid)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    gap: theme.spacing(2),
}));

export const HeaderText = styled('span')(({ theme }) => ({
    fontWeight: 700,
    fontSize: '24px',
    color: theme.palette.text.primary,
}));